import { timeFrameMapping } from '../widget-constants';

export const defaultWidgets = [
  {
    x: 0,
    y: 0,
    h: 7,
    w: 6,
    i: 1,
    title: 'Firewall - Devices By Location',
    timeframe: '',
    timeFrameOptions: [],
    widgetDropDownOption: 'Devices Summary by Location',
    refreshRate: 60,
    dataGroup: 'firewall',
    endpoint: '/devices/locations/summary',
    component: 'map',
    disableTimeFrameDropdown: true,
    drillDownUrl: '/m/nsm/devices/device-management',
    preview: 'mapPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 2,
    title: 'Firewall - summary',
    timeframe: '',
    timeFrameOptions: [],
    widgetDropDownOption: 'Devices Summary',
    refreshRate: 60,
    dataGroup: 'firewall',
    endpoint: '/devices/locations/summary',
    component: 'horizontalBarChart',
    disableTimeFrameDropdown: true,
    preview: 'horizontalBarChartPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 3,
    title: 'Firewall - Insights',
    timeframe: '',
    timeFrameOptions: [],
    widgetDropDownOption: 'Threat Insights',
    refreshRate: 60,
    dataGroup: 'firewall',
    endpoint: '/reportlite/reports',
    component: 'verticalStatus',
    disableTimeFrameDropdown: true,
    // drillDownUrl: '/m/dashboard/overview/status/device',
    drillDownUrl : '/m/mgmt/monitor/details/essential',
    preview: 'verticalStatusPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 6,
    i: 4,
    title: 'Firewall - Top Applications',
    timeframe: timeFrameMapping.last24Hours,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
    ],
    widgetDropDownOption: 'Top Applications',
    refreshRate: 60,
    dataGroup: 'firewall',
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    groupByOptions: [
      'sessions',
      'data sent',
      'data received',
      'virus',
      'intrusion',
      'spyware',
      'total data transferred',
      'total blocked',
    ],
    groupBy: 'sessions',
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/1',
    drillDownUrl: '/m/analytics/reports/summary/essential/91',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/1',
    preview: 'donutChartPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 5,
    title: 'Firewall - Observed Threats',
    timeframe: timeFrameMapping.last24Hours,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
    ],
    widgetDropDownOption: 'Observed Threats',
    dataGroup: 'firewall',
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    isPercentage: false,
    refreshRate: 60,
    disableTimeFrameDropdown: false,
    drillDownUrl: [
      '/m/analytics/reports/summary/94',
      '/m/analytics/reports/summary/95',
      '/m/analytics/reports/summary/96',
      '/m/mgmt/monitor/details/essential/1',
    ],
    advancedDrillDownUrl: '/m/analytics/reports/summary/advance/21',
    preview: 'donutChartPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 6,
    title: 'Firewall - Top Users',
    timeframe: timeFrameMapping.last24Hours,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
    ],
    widgetDropDownOption: 'Top Users',
    refreshRate: 60,
    dataGroup: 'firewall',
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    isPercentage: true,
    component: 'donutChart',
    groupByOptions: [
      'sessions',
      'data sent',
      'data received',
      'virus',
      'intrusion',
      'spyware',
      'access rule blocked',
      'threat blocked',
      'geoIP blocked',
      'botnet blocked',
      'total data transferred',
      'total blocked',
    ],
    groupBy: 'sessions',
    disableTimeFrameDropdown: false,
    drillDownUrl: '/m/analytics/reports/summary/essential/92',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/2',
    preview: 'donutChartPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 7,
    title: 'Firewall - Top Addresses',
    timeframe: timeFrameMapping.last24Hours,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
    ],
    widgetDropDownOption: 'Top Addresses',
    refreshRate: 60,
    dataGroup: 'firewall',
    endpoint: '/reportlite/reports',
    advancedEndpoint: '/ang/tg/report',
    component: 'donutChart',
    groupByOptions: ['sessions', 'data sent', 'data received'],
    groupBy: 'sessions',
    disableTimeFrameDropdown: false,
    // drillDownUrl: '/m/mgmt/monitor/details/essential/3',
    drillDownUrl: '/m/analytics/reports/summary/essential/93',
    advancedDrillDownUrl: '/m/analytics/reports/summary/advanced/3',
    preview: 'donutChartPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 8,
    title: 'Capture client - Affected Devices',
    timeframe: '',
    widgetDropDownOption: 'Device Status',
    refreshRate: 60,
    dataGroup: 'capture client',
    endpoint: '/s1/threats/summary',
    component: 'horizontalStatus',
    disableTimeFrameDropdown: true,
    drillDownUrl: [
      '/protect/devices?infected=Infected',
      '/protect/devices?online=offline',
      '/protect/devices?commissioned=decommissioned',
      '/protect/devices?userActionsNeeded=reboot_category,missing_permissions_category,unprotected_category,agent_suppressed_category,incompatible_os_category',
    ],
    preview: 'horizontalStatusPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 9,
    title: 'Capture client - Unresolved Threats',
    timeframe: '',
    widgetDropDownOption: 'Threat Status',
    refreshRate: 60,
    dataGroup: 'capture client',
    endpoint: '/s1/threats/summary',
    component: 'horizontalStatus',
    disableTimeFrameDropdown: true,
    drillDownUrl: [
      '/threats?status=not_mitigated&resolution=unresolved',
      '/threats?status=mitigated&resolution=unresolved',
      '/threats?status=marked_as_benign&resolution=unresolved',
      '/threats?status=not_mitigated&confidenceLevels=suspicious&resolution=unresolved',
    ],
    preview: 'horizontalStatusPreview',
    moved: false,
  },
  {
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 10,
    title: 'Capture client - Vulnerable Applications',
    timeframe: '',
    widgetDropDownOption: 'Application Status',
    refreshRate: 60,
    dataGroup: 'capture client',
    endpoint: '/s1/applications/count',
    component: 'horizontalStatus',
    disableTimeFrameDropdown: true,
    drillDownUrl: [
      '/applications?riskLevel=critical',
      '/applications?riskLevel=high',
      '/applications?riskLevel=medium',
      '/applications?riskLevel=low',
    ],
    preview: 'horizontalStatusPreview',
    moved: false,
  },
  {
    dataGroup: 'wireless',
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 11,
    title: 'Wireless - Traffic by Data Consumption',
    timeframe: timeFrameMapping.last24Hours,
    widgetDropDownOption: 'Traffic by Data Consumption',
    refreshRate: 60,
    endpoint: '/statistics/topn/all',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    groupBy: 'access points',
    groupByOptions: [
      'access points', 'clients' , 'zones', 'fingerprints', 'ssids',
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl : '/m/dashboard',
  },
  {
    dataGroup: 'wireless',
    x: 0,
    y: 0,
    h: 7,
    w: 3,
    i: 12,
    title: 'Wireless - Number of Clients',
    timeframe: timeFrameMapping.last24Hours,
    widgetDropDownOption: 'Number of Clients',
    refreshRate: 60,
    // endpoint: '/statistics/locations/clients',
    endpoint: '/statistics/topn/all',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    groupBy: 'access points',
    groupByOptions: [
      'access points', 'zones', 'ssids',
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl : '/m/devices/clients',
  },
  {
    dataGroup: 'wireless',
    x: 0,
    y: 0,
    h: 7,
    w: 6,
    i: 13,
    title: 'Wireless - Access Point Status',
    timeframe: '',
    widgetDropDownOption: 'Access Point Status',
    refreshRate: 60,
    endpoint: '/devices/inventory/aps',
    component: 'donutChart',
    preview: 'donutChartPreview',
    disableTimeFrameDropdown: true,
  },
];
